var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { lg: "12" } }, [
        !_vm.becasExtranjero
          ? _c(
              "h3",
              {
                staticClass: "mt-4 mb-4",
                attrs: { "v-text": _vm.$t("area-conocimiento.title") },
              },
              [_vm._v("Área de conocimiento")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "h4",
          {
            staticClass: "mt-4 mb-4",
            attrs: { "v-text": _vm.$t("area-conocimiento.title") },
          },
          [_vm._v("Área de conocimiento")]
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { lg: "12" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12", md: "12", lg: "6" } },
                [
                  _c("input-select-one", {
                    attrs: {
                      id: "area-id",
                      label: _vm.$t("area-conocimiento.area.label"),
                      options: _vm.catArea,
                      readonly: _vm.areaLectura,
                      required: true,
                      tooltip: _vm.$t("area-conocimiento.area.tooltip"),
                      valid: _vm.$v.areaConocimiento.area.$dirty
                        ? !_vm.$v.areaConocimiento.area.$error
                        : null,
                      validationsCommons: {
                        requiredValue: !_vm.$v.areaConocimiento.area.required,
                        requiredMessage: _vm.$t(
                          "area-conocimiento.area.validations.required"
                        ),
                      },
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onAreaChanged($event)
                      },
                    },
                    model: {
                      value: _vm.$v.areaConocimiento.area.$model,
                      callback: function ($$v) {
                        _vm.$set(_vm.$v.areaConocimiento.area, "$model", $$v)
                      },
                      expression: "$v.areaConocimiento.area.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "12", md: "12", lg: "6" } },
                [
                  _c("input-select-one", {
                    attrs: {
                      id: "campo-id",
                      label: _vm.$t("area-conocimiento.campo.label"),
                      options: _vm.catCampo,
                      readonly: _vm.campoLectura,
                      required: true,
                      tooltip: _vm.$t("area-conocimiento.campo.tooltip"),
                      valid: _vm.$v.areaConocimiento.campo.$dirty
                        ? !_vm.$v.areaConocimiento.campo.$error
                        : null,
                      validationsCommons: {
                        requiredValue: !_vm.$v.areaConocimiento.campo.required,
                        requiredMessage: _vm.$t(
                          "area-conocimiento.campo.validations.required"
                        ),
                      },
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onCampoChanged($event)
                      },
                    },
                    model: {
                      value: _vm.$v.areaConocimiento.campo.$model,
                      callback: function ($$v) {
                        _vm.$set(_vm.$v.areaConocimiento.campo, "$model", $$v)
                      },
                      expression: "$v.areaConocimiento.campo.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "12", md: "12", lg: "6" } },
                [
                  _c("input-select-one", {
                    attrs: {
                      id: "disciplina-id",
                      label: _vm.$t("area-conocimiento.disciplina.label"),
                      options: _vm.catDisciplina,
                      readonly: _vm.disciplinaLectura,
                      required: true,
                      tooltip: _vm.$t("area-conocimiento.disciplina.tooltip"),
                      valid: _vm.$v.areaConocimiento.disciplina.$dirty
                        ? !_vm.$v.areaConocimiento.disciplina.$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.areaConocimiento.disciplina.required,
                        requiredMessage: _vm.$t(
                          "area-conocimiento.disciplina.validations.required"
                        ),
                      },
                    },
                    on: {
                      change: function ($event) {
                        return _vm.onDisciplinaChanged($event)
                      },
                    },
                    model: {
                      value: _vm.$v.areaConocimiento.disciplina.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.areaConocimiento.disciplina,
                          "$model",
                          $$v
                        )
                      },
                      expression: "$v.areaConocimiento.disciplina.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { sm: "12", md: "12", lg: "6" } },
                [
                  _c("input-select-one", {
                    attrs: {
                      id: "subdisciplina-id",
                      label: _vm.$t("area-conocimiento.subdisciplina.label"),
                      options: _vm.catSubdisciplina,
                      readonly: _vm.subdisciplinaLectura,
                      required: true,
                      tooltip: _vm.$t(
                        "area-conocimiento.subdisciplina.tooltip"
                      ),
                      valid: _vm.$v.areaConocimiento.subdisciplina.$dirty
                        ? !_vm.$v.areaConocimiento.subdisciplina.$error
                        : null,
                      validationsCommons: {
                        requiredValue:
                          !_vm.$v.areaConocimiento.subdisciplina.required,
                        requiredMessage: _vm.$t(
                          "area-conocimiento.subdisciplina.validations.required"
                        ),
                      },
                    },
                    model: {
                      value: _vm.$v.areaConocimiento.subdisciplina.$model,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.$v.areaConocimiento.subdisciplina,
                          "$model",
                          $$v
                        )
                      },
                      expression: "$v.areaConocimiento.subdisciplina.$model",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-overlay", {
                attrs: {
                  show: _vm.showAC,
                  "no-wrap": "",
                  "spinner-type": "grow",
                  "spinner-variant": "primary",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }